<script>
import { AppLayout, PageHeader } from '@/components/layout'
import appConfig from '@/app.config'
import api from '@/helpers/api'
import { authComputed } from '@/state/helpers'
import _sortBy from 'lodash/sortBy'
/**
 * Shop Component
 */
export default {
  page: {
    title: 'Shop',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    AppLayout,
    PageHeader
  },
  data () {
    return {
      productsData: [],
      formsData: [],
      formsTotalRows: 0,
      isLoading: false,
      productsTotalRows: 0,
      title: 'Shop',
      items: [
        {
          text: 'Shop',
          active: true
        }
      ]
    }
  },
  mounted () {
    this.onRefresh()
  },
  computed: {
    filters () {
      const default_filters = [
        { is_webshop_item: { _eq: true } },
        { is_discontinued: { _eq: false } }
        //{ shops: { _is_null: false } }
      ]
      if (this.userRole === 'admin') return [{ _and: [...default_filters] }]
      else if (this.userRole === 'user') {
        //const { allowed_shops = [] } = this.userProfile.preferences
        return [
          {
            _and: [
              ...default_filters
              //{ shops: { _has_keys_any: [...allowed_shops] } }
            ]
          }
        ]
      } else {
        return [...default_filters]
      }
    },
    ...authComputed
  },
  methods: {
    async onRefresh () {
      this.isLoading = true
      const service = this.userRole === 'admin' ? api.items : api.items
      let { items, total_rows } = await service.fetchPage({
        page: this.currentPage,
        pageSize: this.perPage === 'All' ? -1 : this.perPage,
        needle: this.search,
        filters: [...this.filters]
      })

      var sortedItems = _sortBy(
        [
          ...items.map(p => {
            const { favorite_products = [] } = this.userProfile.preferences
            return {
              ...p,
              is_favorite: favorite_products.includes(p.id)
            }
          })
        ],
        p => !p.is_favorite
      )

      this.productsData = sortedItems.filter(
        item => item.webshop_custom_form === null
      )
      this.formsData = sortedItems.filter(
        item => item.webshop_custom_form !== null
      )
      //this.data = items
      this.isLoading = false
    }
  }
}
</script>

<template>
  <AppLayout>
    <PageHeader :title="title" :items="items" />
    <g-overlay :show="isLoading">
      <b-card no-body class="p-2 d-xs-none" v-if="false"> filters enzo </b-card>
      <b-row no-gutters>
        <h6>{{ $t('forms') }}</h6>
      </b-row>
      <b-row no-gutters>
        <template v-for="form in formsData">
          <b-col cols="12" :key="form.id">
            <app-form-shop-card :product="form" />
          </b-col>
        </template>
      </b-row>

      <template v-if="false">
        <b-row no-gutters>
          <h5>{{ $t('products') }}</h5>
        </b-row>

        <b-card no-body class="p-2">
          <b-row no-gutters v-if="productsData.length > 0">
            <template v-for="product in productsData">
              <b-col cols="12" xl="2" lg="2" md="4" :key="product.id">
                <app-product-shop-card :product="product" />
              </b-col>
            </template>
          </b-row>
          <b-row
            no-gutters
            v-else
            class="justify-content-center text-center d-flex flex-column"
            ><span class="text-muted py-3 text-uppercase font-size-14"
              >No Products</span
            >
            <i class="fas fa-search font-size-24 text-danger"></i><br />
          </b-row>
        </b-card>
      </template>
    </g-overlay>
  </AppLayout>
</template>
